/**
 * 加载geojson面数据，具有zIndex属性
 * time:2020-6-30
 *
 */
import { Cartesian3, Color as CesiumColor, CustomDataSource, PolylineOutlineMaterialProperty
} from "cesium/Cesium";

let PolygonLayer = function(jsonData, options) {
    if (options) {
      this.fillColor = options.fillColor ? this._colorValue(options.fillColor) : [0, 1, 1, 0.6];
      this.outlineColor = options.outlineColor ? this._colorValue(options.outlineColor) : [0, 1, 1, 1];
      this.outlineWidth = options.outlineWidth || 1;
      if (options.propertyName) {
        this.options = options;
      }
    } else {
      this.fillColor = [0, 1, 1, 0.6];
      this.outlineColor = [0, 1, 1, 1];
      this.outlineWidth = 1;
    }
    this.source = new CustomDataSource("polygonDataSouce");
    this._loadData(jsonData);
};

PolygonLayer.prototype = {
    _colorValue(c) {
      let c1 = [c[0] / 255, c[1] / 255, c[2] / 255, c[3]];
      return c1;
    },
    getStyleFromProperty(f) {
      let style = {};
      if (this.options) {
        this.options.styles.forEach(s => {
          if (s.value === f.properties[this.options.propertyName]) {
            let fillColor = this._colorValue(s.fillColor);
            let outlineColor = this._colorValue(s.outlineColor);
            style.fillColor = new CesiumColor(fillColor[0], fillColor[1], fillColor[2], fillColor[3]);
            style.outlineColor = new CesiumColor(outlineColor[0], outlineColor[1], outlineColor[2], outlineColor[3]);
            style.outlineWidth = s.outlineWidth;
          }
        });
      } else {
        style.fillColor = new CesiumColor(this.fillColor[0], this.fillColor[1], this.fillColor[2], this.fillColor[3]);
        style.outlineColor = new CesiumColor(this.outlineColor[0], this.outlineColor[1], this.outlineColor[2], this.outlineColor[3]);
        style.outlineWidth = this.outlineWidth;
      }
      return style;
    },
    _loadData(data) {
      data.features.forEach(f => {
        let style = this.getStyleFromProperty(f);
        let positions = [];
        let zIndex = f.properties.zIndex || 0;
        f.geometry.coordinates[0][0].forEach(c => {
          let position = Cartesian3.fromDegrees(c[0], c[1], 0);
          positions.push(position);
        });
        this.source.entities.add({
          polygon: {
            hierarchy: positions,
            perPositionHeight: false,
            material: style.fillColor,
            outline: false,
            zIndex: zIndex
          },
          properties: f.properties
        });
        this.source.entities.add({
              polyline: {
                clampToGround: true,
                positions: positions,
                width: style.outlineWidth,
                material: new PolylineOutlineMaterialProperty({
                    color: style.outlineColor,
                    outlineWidth: 0,
                    outlineColor: CesiumColor.BLACK
                }),
                zIndex: zIndex
            },
            properties: f.properties
          });
      });
    },
    getStyleByValue(value, styles) {
      let style = {};
      styles.forEach(s => {
          if (s.value === value) {
            let fillColor = this._colorValue(s.fillColor);
            let outlineColor = this._colorValue(s.outlineColor);
            style.fillColor = new CesiumColor(fillColor[0], fillColor[1], fillColor[2], fillColor[3]);
            style.outlineColor = new CesiumColor(outlineColor[0], outlineColor[1], outlineColor[2], outlineColor[3]);
            style.outlineWidth = s.outlineWidth;
          }
        });
      return style;
    },
    setStyle(propertyName, styles) {
      this.source.entities.values.forEach(e => {
        let value = e.properties[propertyName].getValue();
        let style = this.getStyleByValue(value, styles);
        if (Object.keys(style).length) {
          if (e.polygon) {
            e.polygon.material = style.fillColor;
          }
          if (e.polyline) {
            e.polyline.width = style.outlineWidth;
            e.polyline.material = new PolylineOutlineMaterialProperty({
              color: style.outlineColor,
              outlineWidth: 0,
              outlineColor: CesiumColor.BLACK
            });
          }
        }
      });
    }
};

export default PolygonLayer;

// 事例代码
// let polygonLayer = new PolygonLayer(polygonData,
//   {
//    propertyName: "type",
//    styles: [
//   { value: "1", fillColor: [255, 0, 255, 0], outlineColor: [0, 200, 0, 1], outlineWidth: 2 },
//   { value: "2", fillColor: [0, 0, 255, 0], outlineColor: [255, 0, 0, 1], outlineWidth: 2 },
//   { value: "3", fillColor: [255, 244, 0, 0], outlineColor: [255, 0, 0, 1], outlineWidth: 2 }
// ] });

// window.viewer.dataSources.add(polygonLayer.source);
// setTimeout(() => {
//   polygonLayer.setStyle("type", [
//   { value: "2", fillColor: [0, 255, 0, 0], outlineColor: [0, 0, 255, 1], outlineWidth: 2 }
//  ]);
// }, 12000);
